module.exports = __webpack_public_path__ + "img/purpose_build.57465715.svg";